import { all, call, put, takeEvery } from "redux-saga/effects";
import * as deviceActions from "../slices/deviceSlice";

import deviceApis from "src/api/device";

import { common } from "src/types/index";
import { constants } from "src/constants/common";
import {
  AVAILABLE_DEVICES,
  CONNECTED_DEVICES,
} from "src/data/app/devices_json";

// login patient saga
const GetAvailableDevicesSaga = function* GetAvailableDevicesSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  // yield put(deviceActions.getAvailableDevicesSuccess(AVAILABLE_DEVICES));
  try {
    const response: common.ResponseGenerator = yield call(
      deviceApis.getAvailableDevices,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(deviceActions.getAvailableDevicesSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      deviceActions.getAvailableDevicesError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const GetConnectedDevicesSaga = function* GetConnectedDevicesSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  // yield put(deviceActions.getConnectedDevicesSuccess(CONNECTED_DEVICES));
  try {
    const response: common.ResponseGenerator = yield call(
      deviceApis.getConnectedDevices,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(
      deviceActions.getConnectedDevicesSuccess(response?.data?.devices)
    );
    resolve(response);
  } catch (error) {
    yield put(
      deviceActions.getConnectedDevicesError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* deviceSaga() {
  yield all([
    takeEvery(
      deviceActions.getAvailableDevicesRequest,
      GetAvailableDevicesSaga
    ),
    takeEvery(
      deviceActions.getConnectedDevicesRequest,
      GetConnectedDevicesSaga
    ),
  ]);
}
